import { render } from "./CircularToggle.vue?vue&type=template&id=ef2c0abc&scoped=true"
import script from "./CircularToggle.vue?vue&type=script&lang=js"
export * from "./CircularToggle.vue?vue&type=script&lang=js"

import "./CircularToggle.vue?vue&type=style&index=0&id=ef2c0abc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ef2c0abc"

export default script